export const firebaseConfig = {
  apiKey: 'AIzaSyBfKe3NGrSNwqwlbp03_KbvJlDzIug3ME4',
  authDomain: 'newtail-tv.firebaseapp.com',
  projectId: 'newtail-tv',
  storageBucket: 'newtail-tv.appspot.com',
  messagingSenderId: '449774357708',
  appId: '1:449774357708:web:57865ac0c3f9841219c669',
  measurementId: 'G-GH5QDH0Z50'
}
